(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["popup-plate-disclaimer-show-plate"] && !window.DesignMode) return;
  try {
    
      $(document).ready(function() {
        $('#informationBtn').on('click', (e) => {

            $('body').css('overflow','hidden')
            $('#popup').fadeIn("fast");
            $('[data-containerMain]').removeClass('hidden');
            $('.popup-wrapper').css('align-items', 'flex-end')

            //when opening the popup
            $("#popUpinnerContainer").animate({
                opacity: '1',
            });

            //when clicking on the cross
            $('#cross').off('click').on('click', (e) => {
                $("#popUpinnerContainer").animate({
                    opacity: '0',
                });
                $('#popup').removeClass('flex').fadeOut("fast");
                $('body').css('overflow','visible');
            });
        })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-plate-disclaimer-upload-doc"] && !window.DesignMode) return;
  try {
    
      $(document).ready(function() {
        setTimeout(() => {
          $('.globo-description a')[0].href = '#';
          $('.globo-description a').removeAttr('target');
        
          $('.globo-description a').on('click', (e) => {
            $('body').css('overflow', 'hidden');
            $('#popup').fadeIn("fast");
            $('[data-containerMain]').removeClass('hidden');
            $('.popup-wrapper').css('align-items', 'flex-end');
        
            // when opening the popup
            $("#popUpinnerContainer").animate({
              opacity: '1',
            });
        
            // when clicking on the cross
            $('#cross').off('click').on('click', (e) => {
              $("#popUpinnerContainer").animate({
                opacity: '0',
              });
              $('#popup').removeClass('flex').fadeOut("fast");
              $('body').css('overflow', 'visible');
            });
          });
        }, 500);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-plate-disclaimer"] && !window.DesignMode) return;
  try {
    
      $(document).ready(function() {
        $('#informationBtn').on('click', (e) => {

            $('body').css('overflow','hidden')
            $('#popup').fadeIn("fast");
            $('[data-containerMain]').removeClass('hidden');
            $('.popup-wrapper').css('align-items', 'flex-end')

            //when opening the popup
            $("#popUpinnerContainer").animate({
                opacity: '1',
            });

            //when clicking on the cross
            $('#cross').off('click').on('click', (e) => {
                $("#popUpinnerContainer").animate({
                    opacity: '0',
                });
                $('#popup').removeClass('flex').fadeOut("fast");
                $('body').css('overflow','visible');
            });
        })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-custom"] && !window.DesignMode) return;
  try {
    
    class tabs{
    constructor(){
        this.events()
    };

    events(){
        var self = this;
        $(`.tab button`).on('click', (e) => {
            self.openCity(e, e.target.dataset.id)
        })
    };

    openCity(evt, cityName) {
        // Declare all variables
        var i, tabcontent, tablinks;
      
        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
        }
      
        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
      
        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(cityName).style.display = "block";
        evt.currentTarget.className += " active";
    };
};

let startTabs = new tabs();

  } catch(e) { console.error(e); }
})();

})();
